'use strict';

class MonkeypoxSubscriptionCtrl {
    constructor(
        MonkeypoxSubscriptionApi, notificationService, Cities
    ) {
        'ngInject';
        this.monkeypoxSubscriptionApi = MonkeypoxSubscriptionApi;
        this.notificationService = notificationService;
        this.isTest = location.hostname.includes('test') || location.hostname.includes('localhost');
        this.Cities = Cities;
        this.selectedCity = undefined;
        this.subscribed = false;
        this.person = {
            lastname: '',
            firstname : '',
            ssin: '',
            birthdate: '',
            postalcode: '',
            email:'',
            gsm:'',
            policyAccepted: false,
            reset:false,
            notificationRun:false
        };

    }

    $onInit() {
        return this.Cities.load();
    }

    zoekPlaats(zoekTerm) {
        return this.Cities.search(zoekTerm);
    }

    subscribe(){
        this.person.postalcode = this.selectedCity.postalCode.toLowerCase();
        var pathArray = window.location.pathname.split( '/' );
        var inschrijvenPart = pathArray.indexOf('inschrijven');
        this.person.notificationRun = this.person.notificationRun ? 1 : 0;
        this.monkeypoxSubscriptionApi.subscribe(pathArray[inschrijvenPart-1], this.person)
            .then(()=>this._onSubscribed());
    }

    _onSubscribed(){
        this.notificationService.showSuccess(doclrVertaal.instant('monkeypox.subscribe.subscribed.message'));
        this.subscribed = true;
    }
}

(function () {
    angular.module('doclr.monkeypoxsubscription')
        .component('monkeypoxSubscription', {

            templateUrl: '/partials/monkeypoxsubscription/monkeypoxsubscription.component.html',
            controller: MonkeypoxSubscriptionCtrl,
            controllerAs: 'MonkeypoxSubscriptionCtrl'
        });
})();
